<template>
  <div class="box">
    <div class="content">
      <div class="top">
        <div class="top_content">
          <!-- 圆 -->
          <div class="circle" v-for="(it, ind) in str" :key="ind">
            <div
              class="y1"
              :class="[it.name == noTest[num].name ? 'blue' : '']"
              :style="
                it.status === 1 ? 'background:#68BF7B' : 'background:#F1F1F1'
              "
            >
              <div
                class="y2"
                :class="it.name === noTest[num].name ? 'blue1' : ''"
                :style="
                  it.status === 1
                    ? 'background:#68BF7B;color:#fff'
                    : 'background:#F1F1F1;color:#333'
                "
              >
                {{ it.name }}
              </div>
            </div>
            <div class="x"></div>
          </div>
        </div>
      </div>
      <div class="center">
        <div class="top_title">
          <div class="lefts"><img src="./images/left.png" alt="" /></div>
          <div class="centers">{{ noTest[num].name }}测试题</div>
          <div class="rights"><img src="./images/right.png" alt="" /></div>
        </div>
      </div>
      <div class="progress_bar">
        <div class="progress_left">
          <div class="long"></div>
          <div class="short" :style="{ width: widths + `%` }"></div>
        </div>
        <div class="progress_right">
          <div class="num">{{ idx + 1 }}</div>
          <div class="num1">/{{ list.scaleQuestions.length }}</div>
        </div>
      </div>
      <!-- 单选题目内容 -->
      <div class="body" v-if="list.questionsType === 1">
        <!-- 多选 -->
        <div
          class="body_box"
          v-for="(item, index) in list.scaleQuestions"
          :key="index"
          v-show="index === idx"
        >
          <div class="body_title">
            {{ `${item.sort}、 ${item.title} ` }}
          </div>
          <div class="options">
            <div class="rad" v-for="(t, i) in item.answer" :key="i">
              <el-checkbox
                v-model="t.score"
                :true-label="t.value"
                false-label=""
                >{{ `${t.key}. ${t.name} ` }}</el-checkbox
              >
            </div>
            <div class="btn">
              <button class="btn1" @click="up(index)">重新测试</button>
              <button
                class="btn2"
                v-if="list.scaleQuestions.length - 1 == idx"
                @click="next1(index)"
              >
                提交进入下一步
              </button>
              <button class="btn3" v-else @click="next(index)">下一题</button>
            </div>
          </div>
        </div>
      </div>

      <!-- 单选题目内容 -->
      <div class="body" v-if="list.questionsType === 0">
        <!-- 单选 -->
        <div
          class="body_box"
          v-for="(item, index) in list.scaleQuestions"
          :key="index"
          v-show="index === idx"
        >
          <div class="body_title">
            {{ `${item.sort}、 ${item.title} ` }}
          </div>
          <div class="options">
            <div class="rad" v-for="(t, i) in item.answer" :key="i">
              <el-radio-group v-model="item.type" @change="next(index)">
                <el-radio :label="t.value">{{
                  `${t.key}. ${t.name} `
                }}</el-radio>
              </el-radio-group>
            </div>
            <div class="btn">
              <button class="btn1" @click="up(index)">重新测试</button>
              <button
                class="btn2"
                v-if="list.scaleQuestions.length - 1 == idx && list.go === 0"
                @click="next0(index,false)"
              >
                提交进入下一步
              </button>
              <button
                class="btn3"
                v-if="list.scaleQuestions.length - 1 == idx && list.go === 1"
                @click="next0(index,true)"
              >
                提交
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- 性格单选题目内容 -->
      <div class="body" v-if="list.questionsType === 3">
        <!-- 单选 -->
        <div
          class="body_box"
          v-for="(item, index) in list.scaleQuestions"
          :key="index"
          v-show="index === idx"
        >
          <div class="body_title">
            {{ `${item.sort}、 ${item.title} ` }}
          </div>
          <div class="options">
            <div class="rad" v-for="(t, i) in item.answer" :key="i">
              <el-radio-group v-model="item.type" @change="next(index)">
                <el-radio :label="t.value">{{
                  `${t.key}. ${t.name} `
                }}</el-radio>
              </el-radio-group>
            </div>
            <div class="btn">
              <button class="btn1" @click="up(index)">重新测试</button>
              <button
                class="btn2"
                v-if="list.scaleQuestions.length - 1 == idx"
                @click="next3(index)"
              >
                提交进入下一步
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetScaleQuestions,
  CustomBusScale,
  getcustommaproccess,
} from "@/api/home";
export default {
  name: "XTesting",

  data() {
    return {
      isProcessing: false, // 防止重复
      testTime: "",
      report: 0,
      sclId: "",
      list: "",
      str: "",
      idx: 0,
      widths: 0,
      noTest: [],
      num: 0,
      data: {
        ScaleId: "",
        CustomId: "",
        Inputs: [],
      },
    };
  },
  watch: {
    list(newVal) {
      if (newVal !== "") {
        this.getcustomm();
      }
    },
  },
  async mounted() {
    this.data.CustomId = this.$store.state.user.studentInfo.userId;
    await this.getcustomm();
    this.getNoTest();
    this.GetScale(this.num);
  },

  methods: {
    async GetScale(num) {
      const res = await GetScaleQuestions(this.$route.query.noTestScaleId);
      this.list = res.data || res.result;
      this.data.ScaleId = this.noTest[num].scaleId;
    },
    getNoTest() {
      this.str.forEach((t) => {
        if (t.status != 1) {
          this.noTest.push(t);
        }
      });
    },
    async getcustomm() {
      const ress = await getcustommaproccess(
        this.$store.state.user.studentInfo.userId
      );
      console.log("ress", ress);
      this.str = ress.result.mapProccesses;
    },
    up() {
      this.$confirm("真的确定重新测试吗？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.push({ path: "/testing" });
        })
        .catch(() => {});
    },
    async next(index) {
      // 防止重复点击
      if (this.isProcessing) {
        return;
      }

      this.isProcessing = true; // 标志开始处理
      setTimeout(async () => {
        let obj = {
          value: 0,
          name: "",
        };

        // 判断题型并处理逻辑
        if (this.list.questionsType === 1) {
          // 多选题
          if (this.idx !== this.list.scaleQuestions.length - 1) {
            this.list.scaleQuestions[index].answer.forEach((item) => {
              obj.value += parseInt(item.score);
              obj.name = item.tag;
            });
            if (obj.value !== 0) {
              this.data.Inputs.push(obj);
              this.idx++;
              this.widths += 100 / (this.list.scaleQuestions.length - 1);
            } else {
              this.$message.error("你还没选择呢~");
            }
          }
        } else if (this.list.questionsType === 0) {
          // 单选题
          if (this.idx !== this.list.scaleQuestions.length - 1) {
            obj.value = parseInt(this.list.scaleQuestions[index].type);
            this.list.scaleQuestions[index].answer.forEach((item) => {
              obj.name = item.tag;
            });
            if (obj.value !== -1) {
              this.data.Inputs.push(obj);
              this.idx++;
              this.widths += 100 / (this.list.scaleQuestions.length - 1);
            } else {
              this.$message.error("你还没选择呢~");
            }
          }
        } else if (this.list.questionsType === 3) {
          // 性格单选题
          if (this.idx !== this.list.scaleQuestions.length - 1) {
            obj.value = 1; // 假定固定值为1
            this.list.scaleQuestions[index].answer.forEach((item) => {
              obj.name = item.tag;
            });
            if (obj.value !== -1) {
              this.data.Inputs.push(obj);
              this.idx++;
              this.widths += 100 / (this.list.scaleQuestions.length - 1);
            } else {
              this.$message.error("你还没选择呢~");
            }
          }
        }

        // 处理完成后，解除点击限制
        this.isProcessing = false;
      }, 600);
    },
    next1(index) {
      //等于最后一题的时候
      let obj = {
        value: 0,
        name: "",
      };
      this.list.scaleQuestions[index].answer.forEach((item) => {
        obj.value += parseInt(item.score);
        obj.name = item.tag;
      });
      if (obj.value != 0) {
        this.data.Inputs.push(obj);
        if (this.data.Inputs.length == this.list.scaleQuestions.length) {
          // 提交
          this.bus();
          this.widths = 100;
          this.data.Inputs = [];
          this.$message.success("提交成功,即将进入下一项测试");
          setTimeout(() => {
            this.$router.push("/testing");
          }, 2000);
        } else {
          this.$message.error("你还未选择的题目没，请重新开始或查阅~");
        }
      } else {
        return this.$message.error("不能不选择哦~");
      }
    },
    async next0(index,Ygo) {
      //等于最后一题的时候
      let obj = {
        value: 0,
        name: "",
      };
      obj.value = parseInt(this.list.scaleQuestions[index].type);
      this.list.scaleQuestions[index].answer.forEach((item) => {
        obj.name = item.tag;
      });
      if (obj.value != -1) {
        this.data.Inputs.push(obj);
        if (this.data.Inputs.length == this.list.scaleQuestions.length) {
          // 提交
          await this.bus();
          this.widths = 100;
          this.data.Inputs = [];
          if (Ygo) {
            console.log("this.report1", this.report);
            this.$message.success("提交成功,查看报告");
            setTimeout(() => {
              this.$router.push({
                path: "/submit",
                query: {
                  id: this.report,
                  scaleId: this.sclId,
                  createTime: this.testTime,
                },
              });
            }, 2000);
          } else {
            console.log("this.report2", this.report);
            this.$message.success("提交成功,即将进入下一项测试");
            setTimeout(() => {
              this.$router.push("/testing");
            }, 2000);
          }
        } else {
          this.$message.error("你还未选择的题目没，请重新开始或查阅~");
        }
      } else {
        this.$message.error("不能不选择哦~");
      }
    },
    next3(index) {
      //等于最后一题的时候
      let obj = {
        value: 1,
        name: "",
      };
      this.list.scaleQuestions[index].answer.forEach((item) => {
        obj.name = item.tag;
      });
      if (obj.value != -1) {
        this.data.Inputs.push(obj);
        if (this.data.Inputs.length == this.list.scaleQuestions.length) {
          // 提交
          this.bus();
          this.widths = 100;
          this.data.Inputs = [];
          this.$message.success("提交成功,即将进入下一项测试");
          setTimeout(() => {
            this.$router.push("/testing");
          }, 2000);
        } else {
          this.$message.error("你还未选择的题目没，请重新开始或查阅~");
        }
      } else {
        this.$message.error("不能不选择哦~");
      }
    },
    async bus() {
      const res = await CustomBusScale({ ...this.data });
      this.report = res.result.reportId;
      this.sclId = res.result.scaleId;
      this.testTime = res.result.testTime;
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  height: 100%;
  min-width: 1200px;
  background-color: #fff;
  .content {
    width: 100%;
    padding-top: 25px;
    padding: 25px 40px 0 30px;
    .top {
      width: 100%;
      display: flex;
      justify-content: center;
      .top_content {
        display: flex;
        align-items: center;
        justify-content: center;
        .circle {
          display: flex;
          align-items: center;
          .blue {
            background: #cbd7fb !important;
          }
          .blue1 {
            background: #3964e6 !important;
            color: #fff !important;
          }
          .y1 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 80px;
            height: 80px;
            background: #cbd7fb;
            opacity: 1;
            border-radius: 50%;
            .y2 {
              width: 66px;
              height: 66px;
              background: #3964e6;
              opacity: 1;
              text-align: center;
              line-height: 66px;
              border-radius: 50%;
              font-size: 16px;
              color: #fff;
            }
          }
          .x {
            width: 100px;
            height: 1px;
            background: #e8e8e8;
            border-radius: 0px 0px 0px 0px;
            opacity: 1;
          }
        }
        .circle:last-child .x {
          width: 0px;
        }
      }
    }
    .center {
      width: 100%;
      display: flex;
      margin-top: 48px;
      justify-content: center;
      .top_title {
        display: flex;
        align-items: center;
        .lefts {
          width: 40.21px;
          height: 21.21px;
        }
        .centers {
          font-size: 24px;
          color: #333;
          margin: 0 20px;
        }
        .rights {
          width: 40.21px;
          height: 21.21px;
        }
      }
    }
    .progress_bar {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 67px;
      .progress_left {
        position: relative;
        width: 653px;
        height: 15px;
        .long {
          width: 100%;
          height: 100%;
          background: rgba(57, 100, 230, 0.1);
          border-radius: 18px 18px 18px 18px;
          opacity: 1;
        }
        .short {
          position: absolute;
          top: 0;
          left: 0;
          width: 10%;
          height: 100%;
          background: #3964e6;
          border-radius: 18px 18px 18px 18px;
          opacity: 1;
        }
      }
      .progress_right {
        display: flex;
        align-items: center;
        .num {
          font-size: 30px;
          font-weight: bold;
          color: #3964e6;
        }
        .num1 {
          font-size: 20px;
          color: #333;
        }
      }
    }
    .body {
      width: 100%;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      margin: 61px 0;
      box-sizing: border-box;
      .body_box {
        width: 90%;
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        border: 1px solid #c7c7c7;
        .body_title {
          margin: 46px 0 21px 38px;
          font-size: 24px;
          color: #333;
          font-weight: bold;
          box-sizing: border-box;
        }
        .options {
          margin: 0 0 42px 0;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          .rad {
            width: 500px;
            height: 40px;
            line-height: 40px;
            background: #fff; //#f2f6ff
            border-radius: 2px 2px 2px 2px;
            opacity: 1;
            border: 1px solid #eaeaea; // #3964e6;
            margin: 0 50px 30px 50px;
            display: flex;
            align-items: center;
            ::v-deep .el-radio-group {
              width: 100%;
            }
            ::v-deep .el-radio {
              margin-left: 30px;
              width: 100%;
              height: 100%;
              line-height: 40px;
            }
            ::v-deep .el-checkbox {
              margin-left: 30px;
              width: 100%;
              height: 100%;
            }
            ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
              background-color: #3964e6;
              border-color: #3964e6;
            }
            ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
              color: #3964e6;
            }
            ::v-deep .el-checkbox__label {
              font-size: 24px;
            }
          }
          .btn {
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: 55px;
            .btn3 {
              width: 300px;
              height: 60px;
              color: #666666;
              background: #3964e6;
              border-radius: 18px 18px 18px 18px;
              opacity: 1;
              border: 0;
              border: solid 1px #3964e6;
              font-size: 20px;
              line-height: 30px;
              font-size: 24px;
              text-align: center;
              cursor: pointer;
              color: #fff;
            }
            .btn2 {
              width: 300px;
              height: 60px;
              color: #fff;
              background: #68bf7b;
              border-radius: 18px 18px 18px 18px;
              opacity: 1;
              border: 0;
              border: solid 1px #3964e6;
              font-size: 20px;
              line-height: 30px;
              margin-right: 100px;
              font-size: 24px;
              text-align: center;
              cursor: pointer;
            }
            .btn1 {
              width: 300px;
              height: 60px;
              color: #666666;
              background: #fff;
              border-radius: 18px 18px 18px 18px;
              opacity: 1;
              border: 0;
              border: solid 1px #3964e6;
              font-size: 20px;
              line-height: 30px;
              margin-right: 100px;
              font-size: 24px;
              text-align: center;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
